// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const AUTOMATIC_MESSAGE_VIOLATES_RULES = "Nahl\u00e1s nevhodn\u00fd pr\u00edspevok";
export const BLOCK_USER = "Zablokova\u0165 pou\u017e\u00edvate\u013ea";
export const DELETE = "Zma\u017e";
export const FORUM_POST_ADMINCLUB_MENU = "Adminclub";
export const FORUM_POST_EDIT_MENU = "Uprav";
export const FORUM_POST_EDIT_TITLE_MENU = "Uprav nadpis";
export const FORUM_POST_EXCLUDE_FROM_HOMEPAGE = "Vyradi\u0165 z homepage";
export const FORUM_POST_INCLUDE_ON_HOMEPAGE = "Zaradi\u0165 na homepage";
export const FORUM_THREAD_SEO_WITH_AI = "Uprav s AI pre lep\u0161e SEO";
export const PIN_POST = "Pripn\u00fa\u0165 hore";
export const SEND_HEART_TO_username = "Po\u0161li srdie\u010dko %(username)s";
export const SHOW_USERS_WHO_LIKED_THIS_POST = "Zobraz u\u017e\u00edvate\u013eky, ktor\u00fdm sa to p\u00e1\u010di";
export const UNBLOCK_USER = "Odblokova\u0165 pou\u017e\u00edvate\u013ea";
export const UNPIN_POST = "Zru\u0161i\u0165 pripnutie";
